'use strict';

var iconCaseSpotMarker = function(data) {
    return L.divIcon({
        className: 'spot-div-icon',
        iconSize: new L.Point(24, 24),
    });
};

L.Cyclone.SpotMarker = L.Cyclone.Marker.extend({

    options: {
        tagVisible: false,
        iconCase: iconCaseSpotMarker,
        radius: {
            visible: true,
            unitConverter: null
        },
        markerMove: null,
        clickable: false
    },

    initialize: function (options) {
        L.setOptions(this, options);

        this.options.radius = L.extend({}, options.radius);

        this._radius_layers = {};
        this._data = L.extend({
            lat: null,
            lon: null,
            ws: null,
            radius: null
        }, this._data);
        this._initData(this._data, true);
    },

    changeTo: function(data) {
        var self = this,
            _latLng = L.latLng(data.lat, data.lon);

        self._data = data;

        if (data.lat > -99 && _latLng) {
            self.setLatLng(_latLng);
            self._markerMove();

            for (var key in self._radius_layers) {
                if (self._radius_layers[key]) {
                    if (self._map) {
                        self._map.removeLayer(self._radius_layers[key]);
                    }
                    self._radius_layers[key] = null;
                }
            }
            self._radius_layers = {};

            if (self._map && data.radius) {
                self._initRadius();
            }
        }

        return self;
    },

    has_data: function() {
        let _latLng = L.latLng(this._data.lat, this._data.lon);
        return _latLng && (this._data.lat > -99);
    },

    clear_data: function() {
        this._data.lat = null;
        this._data.lon = null;
        this._data.ws = null;
        this._data.radius = null;
        return this;
    }

});


export class TcSpotHandler {

    constructor(map, init_time) {
        this.map = map;
        this.init_time = Date.dtgptime(init_time);
    };

    _create_layer() {
        let color = "#ff977b";
        return new L.Cyclone.SpotMarker({
            radius: {
                r7: {
                    weight: 1,
                    color: color,
                    opacity: 0.8,
                    fillOpacity: 0.2,
                    great_circle: true,
                    density: 1,
                    smoothFactor: 0.1
                },
                visible: true
            },
            zIndexOffset: -1000
        });
    };

    set_dtg(dtg) {
        dtg = Date.dtgptime(dtg).setMinutes(0, 0, 0).valueOf();
        if (this.dtg !== dtg) {
            this.dtg = dtg;
            this.reset_place();
        }
    };

    set_tracks(tracks) {
        this.tracks = tracks;
        this.reset_place();
    };

    reset_place() {
        if (this.tracks) {
            for (let point of this.tracks) {
                let dtime = this.init_time.addHours(point.tau).valueOf();
                if (dtime == this.dtg) {
                    if (!this.layer) {
                        this.layer = this._create_layer();
                    }
                    this.layer.changeTo(point);
                    this.map.addLayer(this.layer);
                }
            }
        }
    };

}
